<!-- custom-->
<div class="body navdata-overview grid grid-cols-1">
    <msc-common-nav [data]="navData"></msc-common-nav>
</div>
<section>
    <router-outlet></router-outlet>
</section>
